import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  IWebSecurityRequest,
  IWebSecurityResponse,
} from "models/WebSecurity/webSecurity.model";
import { WebSecurity } from "services/webSecurity.service";

export const webSecurityAsync = createAsyncThunk(
  "WebSecurity",
  async (): Promise<IWebSecurityResponse> => {
    //webSecReq: IWebSecurityRequest
    try {
      const response = await WebSecurity(); //webSecReq
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);
